/* eslint-disable react/prop-types */
/* eslint-disable react/forbid-prop-types */
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import request from '@api';
// import { PRODUCT_TYPE } from '@constants';
import FullpageLoading from '@components/FullpageLoading';
import { useEffectOnce } from '@hooks';
import useConnectionContext from '@hooks/useConnectionContext';
import Empty from '@components/Empty';
import { Tooltip } from 'antd';
import InfoOutline from '@assets/info_outline.svg';
import { paymentsColumns } from './ListItem';
import classes from './TabPanel.module.css';
// import { getBillingsData } from './mock';
import { formatTime, formatMoney } from '../../utils';

export default function Payments() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [rows, setRows] = React.useState([]);
  const [total, setTotal] = React.useState(0);
  const loadedPage = React.useRef(page);
  const [isEmpty, setIsEmpty] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [dispalyPage, setDispalyPage] = React.useState(-1);
  const isInit = React.useRef(false);
  const { store: { name } } = useConnectionContext();
  const navigate = useNavigate();

  const fetchTransactionList = React.useCallback(() => {
    // const type = tabs[tabIndex].code;
    const body = {
      page,
      pageSize: rowsPerPage,
      // productType: 'BP',
    };
    setIsLoading(true);
    // getBillingsData(1)
    request('billing/payments', {
      path: '/gateway/merchant-service/api/open-platform/',
      method: 'POST',
      body,
    }, {
      handleSessionExpired: () => navigate('/login'),
    })
      .then((res) => {
        const { code, data } = res || {};
        if (code === 0) {
          const { list, total: totalCount, page: currentPage } = data || {};
          loadedPage.current = loadedPage.current <= currentPage ? currentPage : loadedPage.current;
          if (currentPage === 0 && list.length === 0) {
            setIsEmpty(true);
          }
          setRows((_) => _.concat(list.map((item) => {
            const {
              billBizStartDate, billBizEndDate, billingDate, receivablePaidTime, detailDTOList, receivabeInvoiceUrl, settleBillId, refundSummaryDTOList = [],
            } = item;
            const receivableList = [];
            const refundableList = [];
            detailDTOList.forEach((detail) => {
              const {
                status, amount: returnAmount, settleType, paySuccessTs, currency,
              } = detail;
              const time = formatTime(paySuccessTs, 'MMM DD, YYYY', 'UTC');
              const amount = formatMoney(returnAmount / 100, currency);
              if (settleType === 'receivable') {
                receivableList.push({
                  amount, status, time, currency,
                });
              }
              // else if (settleType === 'refundable') {
              //   refundableList.push({
              //     amount, status, time, currency,
              //   });
              // }
            });
            refundSummaryDTOList.forEach((detail) => {
              const amount = formatMoney(detail.totalAmount / 100, detail.currency);
              refundableList.push({
                ...detail,
                amount,
                status: detail.status,
                time: formatTime(detail.paySuccessTs, 'MMM DD, YYYY', 'UTC'),
                currency: detail.currency,
              });
            });
            return {
              // ...item,
              settleBillId,
              receivabeInvoiceUrl,
              billingCycle: `${formatTime(billBizStartDate, 'MMM DD', 'UTC')} - ${formatTime(billBizEndDate, 'MMM DD', 'UTC')}`,
              billingDate: formatTime(billingDate, 'MMM DD, YYYY', 'UTC'),
              premiumsDate: formatTime(receivablePaidTime, '', 'UTC'),
              receivableList,
              refundableList,
            };
          })));
          setDispalyPage(currentPage);
          setTotal(totalCount);
          setIsLoading(false);
        }
      }).catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }, [page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    if (newPage <= loadedPage.current) {
      setDispalyPage(newPage);
    }
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  useEffectOnce(() => {
    isInit.current = true;
    fetchTransactionList();
  }, [fetchTransactionList]);

  React.useEffect(() => {
    if (page > loadedPage.current) {
      fetchTransactionList();
    }
  }, [fetchTransactionList, page, loadedPage.current]);

  React.useEffect(() => {
    if (!isInit.current) {
      isInit.current = true;
      fetchTransactionList();
    }
  }, []);

  return (
    <div style={{ width: '100%' }}>
      {isLoading ? (<FullpageLoading mask />) : null}
      <Paper sx={{
        width: '100%',
        overflow: 'hidden',
        marginBottom: '18px',
        '&.MuiPaper-root': {
          boxShadow: 'none',
        },
      }}
      >

        <TableContainer sx={{ maxHeight: 1200, minWidth: 780 }}>
          <Table stickyHeader aria-label="transaction table">
            <TableHead>
              <TableRow>
                {paymentsColumns.map(({
                  id, align, minWidth, label, labelTip,
                }) => (
                  <TableCell
                    key={id}
                    align={align}
                    style={{ minWidth }}
                  >
                    <div className={classes.table_header_label}>
                      {label}
                      {labelTip && (
                        <Tooltip title={labelTip} placement="top" color="#fff">
                          <img src={InfoOutline} alt="" style={{ marginLeft: 4 }} />

                        </Tooltip>
                      )}
                    </div>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {
                rows.slice(dispalyPage * rowsPerPage, dispalyPage * rowsPerPage + rowsPerPage)
                  .map((row, i) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <TableRow hover tabIndex={-1} key={i}>
                      {paymentsColumns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.format
                              ? column.format(value, { ...row, name })
                              : <section className={classes.transaction_cell}>{value}</section>}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
              }
            </TableBody>
          </Table>
        </TableContainer>
        {isEmpty && <Empty primary="No payments" secondary="You don’t have any payments with Seel yet." />}
        {rows?.length > 0
          && (
            <TablePagination
              component="div"
              count={total}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                '& .MuiTablePagination-selectLabel': {
                  display: 'none',
                },
                '& .MuiInputBase-root': {
                  display: 'none',
                },
              }}
            />
          )}
      </Paper>
    </div>
  );
}
